<div class="d-flex align-items-center">
  <div class="text-right">
    @if (userInfo$ | async; as user) {
      <span class="font-weight-bold">{{user | personName}}</span> <br />
    }
    @if ((hasAuthDataMain$ | async) || isClerkImpersonating()) {
      <a href="javascript:;" (click)="returnToMainAccount()" class="text-dark" style="font-size: 15px;"><u>Return to Main Account</u></a>
      <br />
    }
    <a href="javascript:;" (click)="onLogout()" class="text-dark" style="font-size: 15px;"><u>Sign Out</u></a>
  </div>
  <div>
    <i class="fa fa-user-circle fa-4"></i>
  </div>
</div>
